const ID_ROLE_KEY = "role";

export const getRole = () => {
  try {
    if(window.localStorage && window.localStorage.getItem(ID_ROLE_KEY) !== null){
      return window.localStorage.getItem(ID_ROLE_KEY);
    }
  } catch (error) {
    console.log(error)
  }
};

export const saveRole = role => {
  window.localStorage.setItem(ID_ROLE_KEY, role);
};

export const destroyRole = () => {
  try {
    if(window.localStorage && window.localStorage.getItem(ID_ROLE_KEY) !== null){
      window.localStorage.removeItem(ID_ROLE_KEY);
    }
  } catch (error) {
    console.log(error)
  }
};

export default { getRole, saveRole, destroyRole };